module.exports = __webpack_public_path__ + "img/Flag_of_Norway.d34123ac.svg";